import React from 'react';
import { Spinner } from '@noths/shared-components';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import Types from '../../redux/types';
import { SpinnerWrapper } from './styles';

class SignOut extends React.Component {
  static propTypes = {
    signOut: func.isRequired,
  };

  componentDidMount() {
    this.props.signOut();
  }

  render() {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }
}

export default connect(
  null,
  dispatch => ({
    signOut: () => dispatch({ type: Types.SIGN_OUT }),
  })
)(SignOut);
